export default function NewsletterSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      form.reset();
      return;
    }

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== "website_alt" && value) {
          params.append(key, value.toString());
        }
      });

      const response = await fetch("https://readdy.ai/api/form/d9p1i42ftmtnfcfh0ftg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === "OK") {
        form.reset();
        alert("订阅成功！感谢您的关注。");
      } else {
        alert("订阅失败，请稍后重试。");
      }
    } catch {
      alert("网络错误，请检查网络连接后重试。");
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-6" style={{ fontFamily: "var(--font-heading)" }}>
          订阅更新通知
        </h2>
        <p className="text-sm text-foreground-600 mt-3 max-w-md mx-auto">
          第一时间获取最新漫画更新和平台动态，精彩内容不再错过
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 w-full px-4 py-3 rounded-md text-sm border border-background-200/70 bg-background-50 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            className="w-full sm:w-auto inline-flex items-center px-6 py-3 rounded-md text-sm font-semibold whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            立即订阅
          </button>
        </form>
      </div>
    </section>
  );
}